import React, { useEffect, useState} from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemAvatar';
import Divider from '@mui/material/Divider';
import CircleIcon from '@mui/icons-material/Circle';
import ListItemButton from '@mui/material/ListItemButton';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/solid';
import {hacerScroll} from '../../../Helpers/utilidades-globales' 
import { Button, Card } from '@material-tailwind/react';
import { getBalanceBadgeStyle, getRegionBadgeStyle, getTipoIglesiaBadgeStyle, isBalancePresentado } from '../../ComponentesComunes/identificadoresVisuales';


export const ListadoCelular= ({datos,
    funcionSeleccion,
    setIsIglesiaSeleccionado
    })=>{

const [maximo,setMaximo] = useState(50)

useEffect(()=>{
    setMaximo(50)
},[datos])

useEffect(()=>{
    if(maximo>50){
        hacerScroll(`id-index-${maximo-50}`)
    }
},[maximo])

const mostrarMas = ()=>{
    setMaximo(maximo+50)
}


return <>
        <h4 className='mb-1'>{resumen(datos,maximo)}</h4>
        <Card>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                {datos
                .filter((item,index)=>index<=maximo)
                .map((item,index)=>(
                    <>
                        <ListItem key={item.id_iglesia}>
                            <ListItemIcon sx={{minWidth:'0'}} id={`id-index-${index}`}>
                                <CircleIcon  />
                            </ListItemIcon>
                            <ListItemButton onClick={()=>{funcionSeleccion(item.id_iglesia); setIsIglesiaSeleccionado(true)}}>
                                <ListItemText primary={item.nombre_igl} secondary={<>
                                                                                    <p>{item.pastor ? item.pastor : item.encargado}</p>
                                                                                    <p>{item.provincia}</p>
                                                                                    <p>{item.localidad}</p>
                                                                                    <p>
                                                                                        <span className='inline-flex rounded-full px-2 py-0.5 text-xs font-semibold shadow-sm whitespace-nowrap' style={getTipoIglesiaBadgeStyle(item.tipo_iglesia)}>{item.tipo_iglesia}</span>
                                                                                    </p>
                                                                                    <p>
                                                                                        <span className='inline-flex rounded-full h-6 w-6 items-center justify-center shadow-sm whitespace-nowrap cursor-default' style={getBalanceBadgeStyle(item.balance)} title={`Balance ${item.balance}`} aria-label={`Balance ${item.balance}`}>
                                                                                            {isBalancePresentado(item.balance)
                                                                                                ? <CheckIcon className='h-3.5 w-3.5' />
                                                                                                : <XMarkIcon className='h-3.5 w-3.5' />}
                                                                                        </span>
                                                                                    </p>
                                                                                    <p>
                                                                                        <span className='inline-flex rounded-full px-2 py-0.5 text-xs font-semibold shadow-sm' style={getRegionBadgeStyle(item.id_region)}>R-{item.id_region}</span>
                                                                                    </p>
                                                                                </>}
                                />
                                </ListItemButton>
                            </ListItem>
                        <Divider variant="inset" component="li"  className='relative right-4'/>
                    </>
                ))}
            </List>
        </Card>
        <div className='grid grid-cols-2 mt-2'>
            <p className='mt-2'>{resumen(datos,maximo)}</p>
            {hayMasDatos(datos, maximo) && <Button variant="text" className="flex items-center gap-2" onClick={mostrarMas}>
                Mostrar mas
                <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="h-5 w-5"
                >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                />
                </svg>
            </Button>
            }
        </div>
    </>
}

const hayMasDatos = (datos,maximo) =>{
    if(datos.length>maximo){
        return true
    }
    return false
}

const resumen = (datos,maximo)=>{
return datos.length < maximo ? datos.length == 1 ? '1 resultado': `${datos.length} resultados` : `${maximo} resultados de ${datos.length}`

}

